import React from 'react'
import { App, Button, Card, Col, Row, Space, Typography } from 'antd'
import {
    HomeOutlined,
    SettingOutlined,
    FileTextOutlined,
    PayCircleOutlined,
    PoweroffOutlined,
    ShoppingOutlined,
} from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setLogout } from '../store/loginSlice'

const { Title, Text } = Typography

const QUICK_MENUS = [
    { key: '/H5sysHome', title: '系统首页', icon: <HomeOutlined /> },
    { key: '/H5sysGoodsList', title: '商品管理', icon: <ShoppingOutlined /> },
    { key: '/SysHome/ExpenseList', title: '费用报销', icon: <PayCircleOutlined /> },
    { key: '/SysHome/TechDocList', title: '技术文档', icon: <FileTextOutlined /> },
    { key: '/SysHome/SetDept', title: '部门用户', icon: <SettingOutlined /> },
    { key: '/SysHome/MinePassword', title: '修改密码', icon: <SettingOutlined /> },
]

function H5sysHome() {
    const { modal } = App.useApp()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const userName = JSON.parse(localStorage.getItem('eu_name') || '""') || '未登录用户'


    const logout = () => {
        modal.confirm({
            title: '确定退出登录吗？',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                dispatch(setLogout())
                navigate('/Login', { replace: true })
            },
        })
    }

    return (
        <div
            style={{
                minHeight: '100vh',
                padding: '12px',
                background: '#f5f6f8',
                boxSizing: 'border-box',
            }}
        >
            <Card
                variant="borderless"
                style={{ borderRadius: 12, marginBottom: 12 }}
                styles={{ body: { padding: 14 } }}
            >
                <Space direction="vertical" size={4} style={{ width: '100%' }}>                                       
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text>您好，{userName}</Text>
                        <Button type="primary" icon={<PoweroffOutlined />} size="small" onClick={logout}>
                            退出
                        </Button>
                    </div>
                </Space>
            </Card>

            <Card variant="borderless" style={{ borderRadius: 12 }}>
                <Title level={5} style={{ marginTop: 0 }}>
                    常用功能
                </Title>
                <Row gutter={[10, 10]}>
                    {QUICK_MENUS.map((item) => (
                        <Col span={12} key={item.key}>
                            <Button
                                block
                                onClick={() => navigate(item.key)}
                                style={{
                                    height: 72,
                                    borderRadius: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 8,
                                }}
                            >
                                {item.icon}
                                <span>{item.title}</span>
                            </Button>
                        </Col>
                    ))}
                </Row>
            </Card>
        </div>
    )
}

export default H5sysHome